"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedBar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.StackedBar = function (_a) {
    var stackedData = _a.stackedData, xScaleGroup = _a.xScaleGroup, colorScale = _a.colorScale, yScale = _a.yScale;
    var getAggregateID = function (s) { return s.split('_')[1]; };
    return (react_1.default.createElement(react_1.default.Fragment, null, stackedData.map(function (s) { return (react_1.default.createElement("rect", { width: xScaleGroup.bandwidth(), x: (xScaleGroup.step() - xScaleGroup.bandwidth()) / 2, fill: colorScale({ ID: getAggregateID(s.key) }), y: yScale(s.y1), height: yScale(s.y0) - yScale(s.y1), key: s.key + "-rect", className: "FOS_Bar_Rect", stroke: "white", strokeWidth: 0.5, shapeRendering: "crispEdges" })); })));
};
